import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const ConfirmationPopup = ({
  title,
  confirmationMessage,
  handleYes,
  handleNo,
  yesButtonText,
  noButtonText,
}) => {
  const { t } = useTranslation();
  // useEffect(() => {
  //     const elems = document.getElementsByClassName("confirmation_popup");
  //     for (let i = 0; i < elems.length; i++) {
  //     elems[i].style.display = "block";
  //     }
  // }, []);

  return (
    <div className="custom-alert-pop confirmation_popup">
      <div className="custom-alert-container">
        <div className="custom-alert-wrap">
          <div className="custom-alert-header">
            <h4>{title}</h4>
          </div>
          <div className="custom-alert-body">
            <p>{confirmationMessage}</p>
            <div className="alert-buttons">
              <a onClick={handleYes} className="popup-alert-btn button">
                {yesButtonText || t("yes_txt")}
              </a>
              <a onClick={handleNo} className="popup-alert-btn button">
                {noButtonText || t("no_txt")}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPopup;
